export const CACHE_TIME_TWO_HOURS = 7200000

export const PSYCHOLOGY_SCREEN_EVENT = {
  AT_PSYCHOLOGY_NEW_LIST: 'at_psychology_new_list',
  AT_PSYCHOLOGY_SCHEDULE: 'at_psychology_schedule',
} as const

export const PSYCHOLOGY_INTERACTION_EVENT = {
  SEEN: 'seen',
  SELECT_SLOT_PRESS: 'select_slot_press',
  NEXT_HOUR_PRESS: 'next_hour_press',
  PREV_HOUR_PRESS: 'prev_hour_press',
  SCHEDULE_PRESS: 'schedule_press',
  FULL_PROFILE_PRESS: 'full_profile_press',
  SEEN_WITHOUT_SLOTS: 'seen_without_slots',
  SEEN_WITH_SLOTS: 'seen_with_slots',
  SEARCH_OTHERS_PRESS: 'search_others_press',
  NEW_SLOTS_REQUEST_CLICK: 'new_slots_request_click',
  SHOW_EVALUATIONS_PRESS: 'show_evaluations_press',
  SEARCH_PROFESSIONALS: 'search_professionals',
  CLEAR_FILTERS: 'clear_filters',
  WHAT_SEARCH_FILTER_PRESS: 'what_search_filter_press',
  DURATION_FILTER_PRESS: 'duration_filter_press',
  GENDER_FILTER_PRESS: 'gender_filter_press',
  ETHNICITY_FILTER_PRESS: 'ethnicity_filter_press',
  SHOW_ALL_FILTERS_PRESS: 'show_all_filters_press',
  REASON_FILTER_PRESS: 'reason_filter_press',
  APPROACH_FILTER_PRESS: 'approach_filter_press',
  SPECIALTY_FILTER_PRESS: 'specialty_filter_press',
  PERIOD_FILTER_PRESS: 'period_filter_press',
  LIBRAS_FILTER_PRESS: 'libras_filter_press',
  STATE_FILTER_PRESS: 'state_filter_press',
  CITY_FILTER_PRESS: 'city_filter_press',
  CLEAR_MORE_FILTERS: 'clear_more_filters',
  APPLY_MORE_FILTERS: 'apply_more_filters',
  CLOSE_MORE_FILTERS: 'close_more_filters',
} as const
